import React from "react"
import { useSearchLabels } from "./SearchLabelsContext"
import type { SearchLabels } from "./searchLabelHelpers"

interface ActiveSearchFiltersProps {
  searchFilter: string
  onRemoveToken: (index: number) => void
}

function humanizeToken(token: string, labels: SearchLabels): string {
  const trimmed = token.trim()
  if (!trimmed.includes(":")) return trimmed

  const labelMap: Record<string, string> = {
    contenttype: labels.type,
    industry: labels.industry,
    locale: labels.language,
  }

  const [attr, val] = trimmed.split(":", 2)
  const label = labelMap[attr.toLowerCase()] || attr
  return `${label}: ${val}`
}

export function parseFilterTokens(raw: string): string[] {
  return raw
    .split(/\sAND\s/i)
    .map(t => t.replace(/^\(|\)$/g, "").trim())
    .filter(Boolean)
}

export function rebuildFilter(tokens: string[]): string {
  return tokens.join(" AND ")
}

const ActiveSearchFilters = ({
  searchFilter,
  onRemoveToken,
}: ActiveSearchFiltersProps) => {
  const labels = useSearchLabels()
  const tokens = parseFilterTokens(searchFilter)

  return (
    <div className="nav-search__active-filters">
      <h3 className="nav-search__filter-panel__title">{labels.filteredBy}</h3>
      <ul className="nav-search__filter-list">
        {tokens.map((token, i) => (
          <li key={i} className="nav-search__filter-list__item">
            <button
              className="nav-search__filter nav-search__filter-active nav-search__filter-active--dismissable"
              onClick={e => {
                e.preventDefault()
                onRemoveToken(i)
              }}
            >
              {humanizeToken(token, labels)}
              <span
                className="nav-search__filter-close"
                aria-label={`${labels.removeFilter}: ${humanizeToken(token, labels)}`}
              >
                &times;
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ActiveSearchFilters
